import { Component, DestroyRef, HostBinding, inject, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NGXLogger } from "ngx-logger";
import { AlertService } from "@company-box/services";
import { AlertComponent } from "ngx-bootstrap/alert";
import { ENVIRONMENT } from "@company-box/models";
import { SidebarStateService } from "./services/sidebar-state.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-root",
  standalone: true,
  template: `<router-outlet></router-outlet>
    <alert
      style="position: fixed; top: 4px; right: 4px ; z-index: 1000;"
      [dismissible]="alertService.dismissible()"
      [isOpen]="alertService.alertOpen()"
      [type]="alertService.alertType()"
      [dismissOnTimeout]="alertService.alertTimeout()"
      (onClosed)="alertService.alertOpen.set(false)"
    >
      <span class="pe-5"> {{ alertService.alertMsg() }} </span>
    </alert> `,
  imports: [RouterModule, AlertComponent],
})
export class AppComponent implements OnInit {
  @HostBinding("class.app") readonly hostClass = true;
  @HostBinding("class.sidebar-minimized") sidebarMinimized = false;
  @HostBinding("class.brand-minimized") brandMinimized = false;
  environment: any = inject(ENVIRONMENT);
  alertService: AlertService = inject(AlertService);
  logger: NGXLogger = inject(NGXLogger);
  private sidebarState = inject(SidebarStateService);
  private destroyRef = inject(DestroyRef);

  constructor() {}

  ngOnInit(): void {
    this.updateMenu();
    this.sidebarState.menuMinimizedChanges$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isMinimized) => this.updateMenu(isMinimized));
  }

  private updateMenu(isMinimized = this.isStoredMenuMinimized()): void {
    this.logger.debug(isMinimized ? "menu minimized" : "menu NOT minimized");
    this.sidebarMinimized = isMinimized;
    this.brandMinimized = isMinimized;
  }

  private isStoredMenuMinimized(): boolean {
    return localStorage.getItem("menu.minimized") === "true";
  }
}
